import { CICEnabled } from "./../interfaces/cic-enabled";
import { prop } from "../../decorators/property";
import {BaseRelationModel} from "../models/base-relation";

export class LegislationRelationModel extends BaseRelationModel implements CICEnabled {

    @prop() public ForceShow: boolean;
    @prop() public FilteredOut: boolean;
    @prop() public Collapsed: boolean;
    @prop() public IsHiddenJurisdiction: boolean;
    @prop() public IsActuallyVisible: boolean;
    @prop() public Id: string;
    @prop() public Title: string;
    @prop() public FriendlyUrlTitle: string;
    @prop() public TreatmentOptions: any;
    @prop() public ContextParaCount: number;
    @prop() public PluralContext: boolean;
    @prop() public HasContext: boolean;
    @prop() public TreatmentClass: string;
    @prop() public CitedReferences: any;
    @prop() public Summary: string;
    @prop() public TruncatedSummary: string;
    @prop() public Treatment: any;
    @prop() public Year: number;
    @prop() public Item: string;

    constructor(options?) {
        super(options);
    }

    public setActualVisibility(): void {
        this.IsActuallyVisible =
            (!this.IsHiddenJurisdiction || (this.IsHiddenJurisdiction && this.ForceShow)) && !this.FilteredOut && !this.Collapsed;
    }

    public get FilterableText(): string {
        return "" + this.Item + this.Title; // For some reason legislation docs populate the Item field, category docs populate the title field.
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/legislation-relation.ts